import React from 'react';
export function Testimonials() {
  const testimonials = [{
    before: 'En 14 días ',
    highlight: 'la panza del embarazo desapareció',
    after: '. No cambié todo lo que como, solo entendí qué me hacía mal.',
    author: 'Mariana G., 42',
    location: 'Buenos Aires',
    initial: 'M'
  }, {
    before: 'Fui al gastroenterólogo 4 veces en 2 años. Nadie me habló del SIBO. Este protocolo ',
    highlight: 'me explicó más en el Tomo 1 que todos esos turnos juntos',
    after: '.',
    author: 'Claudia P., 51',
    location: 'Córdoba',
    initial: 'C'
  }, {
    before: 'El semáforo de compras adaptado a Argentina es ',
    highlight: 'un antes y un después',
    after: '. Fui a la feria con la lista y no gasté más que siempre.',
    author: 'Valentina R., 35',
    location: 'Rosario',
    initial: 'V'
  }, {
    before: 'El aceite infusionado con ajo me cambió la vida. ',
    highlight: 'Como con sabor sin inflarme',
    after: '. Eso solo ya vale todo el protocolo.',
    author: 'Florencia M., 47',
    location: 'Mendoza',
    initial: 'F'
  }, {
    before: 'La infusión estrella antes de dormir. Eso fue todo. Empecé a ',
    highlight: 'amanecer con la panza plana por primera vez en 3 años',
    after: '.',
    author: 'Luciana B., 38',
    location: 'La Plata',
    initial: 'L'
  }];
  return <section className="bg-forest-50 py-20 px-4" data-id="element-205">
      <div className="max-w-6xl mx-auto" data-id="element-206">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-forest-900 mb-12" data-id="element-207">
          Historias Reales:
        </h2>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-208">
          {testimonials.map((t, idx) => <div key={idx} className="break-inside-avoid bg-white p-8 rounded-2xl shadow-sm border border-mint/30" data-id="element-209">
              <div className="text-gold-400 text-xl mb-4" data-id="element-210">⭐⭐⭐⭐⭐</div>
              <p className="text-forest-800 text-lg italic mb-8 leading-relaxed" data-id="element-211">
                "{t.before}
                <span className="font-bold not-italic text-solution bg-solution/15 px-1 rounded" data-id="element-212">
                  {t.highlight}
                </span>
                {t.after}"
              </p>
              <div className="flex items-center gap-4" data-id="element-213">
                <div className="w-12 h-12 rounded-full bg-solution/20 flex items-center justify-center text-forest-900 font-bold text-xl" data-id="element-214">
                  {t.initial}
                </div>
                <div data-id="element-215">
                  <p className="font-bold text-forest-900" data-id="element-216">{t.author}</p>
                  <p className="text-sm text-forest-800/70" data-id="element-217">| {t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}